<template>
  <div class="divider"></div>
</template>

<script>
export default {
  name: 'Divider',
};
</script>
